import React, { memo, MouseEventHandler, useRef, useState } from 'react'
import { Trans } from '@lingui/macro'
import './EmbeddedFileElement.less'

interface IIframeProps {
  embedUrl: string
}

const Iframe = memo((props: IIframeProps) => {
  return (
    <iframe
      src={props.embedUrl}
      frameBorder="0"
      width="100%"
      height="100%"
      allowFullScreen
    />
  )
})

export const EmbeddedFileElement = (props: {
  activateEditing?: MouseEventHandler<HTMLAnchorElement>
  embedUrl: string
}) => {
  const [modalShown, setModalShown] = useState(false)
  const refIframe = useRef<HTMLDivElement>(null)

  const closeModal = () => {
    setModalShown(false)
  }

  const openFullScreen = () => {
    const { current } = refIframe
    if (current) {
      // @ts-expect-error
      if (current.webkitRequestFullscreen) {
        // @ts-expect-error
        current.webkitRequestFullscreen() // Safari
      } else {
        current.requestFullscreen()
      }
    }
  }

  let embedUrl: string
  if (!props.embedUrl) {
    return null
  } else {
    embedUrl = props.embedUrl
  }

  return (
    <div className="EmbeddedElement">
      {
        <div className="link-preview">
          <div>
            <div ref={refIframe} className="EmbeddedElement__iframe">
              {embedUrl && <Iframe embedUrl={embedUrl} />}
            </div>

            <div
              title="Click to read"
              className="embedded-tile-wrapper clickable clearfix no-image"
              onClick={() => {
                setModalShown(true)
              }}
            >
              <div className="embedded-tile-instruction">
                <span className="icon-size-fullscreen" />{' '}
                <Trans>Open page reader</Trans>
              </div>
            </div>

            {modalShown && (
              <div className="embedded-page-modal-wrapper modal-wrapper">
                <div className="modal-mask" onClick={closeModal} />
                <div
                  className="embedded-page-modal-body modal-body"
                  ng-click="preventDefault"
                >
                  <div ref={refIframe} className="modal-content">
                    {embedUrl && <Iframe embedUrl={embedUrl} />}
                  </div>

                  <div className="modal-header">
                    <a
                      className="clickable btn btn-default close-modal"
                      onClick={closeModal}
                    >
                      <span className="icon-size-actual" />
                    </a>
                    <div
                      className="clickable btn btn-default"
                      onClick={() => {
                        openFullScreen()
                      }}
                    >
                      <span className="icon-size-fullscreen" />{' '}
                      <Trans>Open full screen</Trans>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {props.activateEditing && (
            <a
              onClick={props.activateEditing}
              className="btn btn-default link-clear"
            >
              <span className="icon-pencil"></span> <Trans>Edit</Trans>
            </a>
          )}
        </div>
      }
    </div>
  )
}
